<style scoped lang="scss">

</style>

<template>
<div>
    <div class="uk-form" v-if="application">

        <fieldset data-uk-margin>
            <legend>Third Party to contact servicer or property management company</legend>


            <p>
                The Applicant and any co-applicants and residents 18 years of age and older (if any) named below
                (individually and collectively, "Borrower Applicant"), authorize the Servicer/Property Management
                Company listed on this application below or the successor/assignee and the following third parties:
            </p>


            <p><strong>{{ application.program.agency_name }}</strong> <br/>
                {{ application.program.program_name }},  {{ application.program.phone }}</p>

            <hr class="uk-grid-divider">

            <p>
                (Individually and collectively, "Third Party") to share, release, discuss, and otherwise provide to and
                with each other public and non-public personal information contained in or related to the mortgage loan
                or the lease of the Applicant. This information may include (but is not limited to) the name, address,
                telephone number, social security number, credit score, income, government monitoring information, loss
                mitigation application status, account balances, program eligibility, and payment activity of the Applicant.
            </p>

            <p>
                The Servicer/Property Management Company/{{ application.program.agency_name }} or successor/assignee will take
                reasonable steps to verify the identity of a Third Party, but has no responsibility or liability to
                verify the identity of such Third Party. The Servicer/Property Management Company/{{ application.program.agency_name }} or its successor/assignee also has no responsibility or liability for what a Third Party does
                with such information.
            </p>

        </fieldset>

        <div class="uk-container uk-margin-top" >
            <div class="uk-grid">
                <div class="uk-panel uk-panel-box uk-width-1-1"> <span class="uk-panel-title"><i class="uk-icon-exclamation-circle uk-icon-large theme-primary-color"></i> <u>Before signing this Third-Party Authorization, beware of foreclosure scams!</u></span>
                    <div class="uk-panel-body">
                        <ul>
                            <li>It is expected that an {{ application.program.program_name }} Servicer/Property Manager Liaison will work directly with your lender/mortgage servicer/property manager.</li>
                            <li>Beware of anyone who asks you to pay a fee in exchange for a counseling service or modification of a delinquent loan or lease.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-margin-large-bottom">
            <fieldset>
                <div class="uk-container uk-margin-top" >
                    <div class="uk-grid" v-if="application.household">
                        <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                            <div v-if="member.age >= 18">
                                <validated-section :errors="errors" :field="'signature_'+member.id">
                                    <signature-box @updated="onSignatureUpdated"
                                                   :user-key="member.id"
                                                   :is-signed="signatureData[member.id] && signatureData[member.id].third_party_authorization_signed_at !== null"
                                                   :completed="signatureData[member.id] && signatureData[member.id].completed"
                                                   :name="member.first_name + ' ' + member.last_name"
                                                   :color="programSettings['primary-program-color']"
                                    ></signature-box>
                                </validated-section>

                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";

    export default {
        name: "Step7",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                signatures: state => state.signatures,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-privacy-policy`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, { third_party_authorization_signed_at: signatureFiltered.created_at, completed: true });
                        }
                    }
                })
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'third_party_authorization_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].third_party_authorization_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            async save() {
                let data = {
                    signatures: this.signatureData,
                }
                let r = axios.put(`/api/hope/applications/${this.application.id}/step-7`, data);
                await this.$store.dispatch('Application/fetch', this.application.id);
            }
        }
    }
</script>
